import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useAuth } from "@/contexts/AuthContext";

const BASE_LINKS = [
	{ label: "Command Centre", path: "/hospital-admin/intelligence" },
	{ label: "Doctor Intelligence", path: "/hospital-admin/intelligence/doctors" },
	{ label: "Department Intelligence", path: "/hospital-admin/intelligence/departments" },
	{ label: "Operations Intelligence", path: "/hospital-admin/intelligence/operations" },
	{ label: "Pharmacy Intelligence", path: "/hospital-admin/intelligence/pharmacy" },
	{ label: "Lab Intelligence", path: "/hospital-admin/intelligence/lab" },
	{ label: "Finance Intelligence", path: "/hospital-admin/intelligence/finance" },
	{ label: "Management Attention", path: "/hospital-admin/intelligence/attention" },
	{ label: "Benchmarks", path: "/hospital-admin/intelligence/benchmarks" },
	{ label: "Settings", path: "/hospital-admin/intelligence/settings", adminOnly: true },
	{ label: "Data Quality", path: "/hospital-admin/intelligence/data-quality", adminOnly: true },
	{ label: "Potential Revenue Leakage", path: "/hospital-admin/intelligence/leakage" },
	{ label: "Insights", path: "/hospital-admin/intelligence/insights" },
];

type Props = { basePath?: string };

export function IntelligenceSubNav({ basePath = "/hospital-admin" }: Props) {
	const location = useLocation();
	const { user } = useAuth();
	const isAdmin = user?.role === "SUPER_ADMIN" || user?.role === "HOSPITAL_ADMIN";
	const links = BASE_LINKS.filter((l) => !l.adminOnly || isAdmin).map((l) => ({
		...l,
		path: l.path.replace("/hospital-admin", basePath),
	}));

	return (
		<nav className="flex flex-wrap gap-2 border-b pb-3 mb-4">
			{links.map((link) => {
				const active =
					location.pathname === link.path ||
					(link.path.endsWith("/doctors") && location.pathname.startsWith(link.path)) ||
					(link.path.endsWith("/departments") && location.pathname.startsWith(link.path)) ||
					(link.path.endsWith("/operations") && location.pathname.startsWith(link.path)) ||
					(link.path.endsWith("/pharmacy") && location.pathname.startsWith(link.path)) ||
					(link.path.endsWith("/lab") && location.pathname.startsWith(link.path)) ||
					(link.path.endsWith("/finance") && location.pathname.startsWith(link.path)) ||
					(link.path.endsWith("/attention") && location.pathname.startsWith(link.path)) ||
					(link.path.endsWith("/benchmarks") && location.pathname.startsWith(link.path)) ||
					(link.path.endsWith("/settings") && location.pathname.startsWith(link.path)) ||
					(link.path.endsWith("/data-quality") && location.pathname.startsWith(link.path)) ||
					(link.path.endsWith("/leakage") && location.pathname.startsWith(link.path)) ||
					(link.path.endsWith("/insights") && location.pathname.startsWith(link.path));
				return (
					<Link
						key={link.path}
						to={link.path}
						className={cn(
							"rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
							active
								? "bg-indigo-100 text-indigo-900"
								: "text-muted-foreground hover:bg-muted hover:text-foreground"
						)}
					>
						{link.label}
					</Link>
				);
			})}
		</nav>
	);
}
